import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Link,
  SxProps,
  Theme,
  Typography,
  useTheme,
} from "@mui/material";
import { Link as RouterDom } from "react-router-dom";
import { Percent } from "../../icons";

type CardProductProps = {
  image: string;
  title: string;
  to: string;
  category?: string;
  price: string;
  comparePrice: string;
  currency: string;
  alt: string;
};
export const CardProduct = ({
  image,
  title,
  to,
  category,
  price,
  comparePrice,
  currency,
  alt,
}: CardProductProps) => {
  const theme = useTheme();
  const getStyle = () => {
    const card: SxProps<Theme> = {
      opacity: 1,
      position: "relative",
      boxShadow:
        "0 0 2px 0 rgba(145 158 171 / 20%), 0 12px 24px -4px rgba(145 158 171 / 12%)",
      transition: "opacity 0.3s ease",
      "&:hover": { opacity: 0.8 },
      borderRadius: 4,
    };
    const link: SxProps<Theme> = {
      color: theme.palette.background.default,
      textDecoration: "none",
    };
    const image: SxProps<Theme> = {
      width: "100%",
      height: { xs: 200, md: 300 },
      borderRadius: 3,
    };
    const cardContent: SxProps<Theme> = {
      display: "flex",
      flexDirection: "column",
      gap: 0.5,
    };
    const category: SxProps<Theme> = {
      textTransform: "uppercase",
      letterSpacing: 0.5,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      fontSize: { xs: 9, md: 10 },
      color: theme.palette.secondary[300],
      fontWeight: 700,
    };
    const title: SxProps<Theme> = {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      width: "90%",
      fontSize: { xs: 13, md: 14 },
      color: theme.palette.secondary.main,
      fontWeight: 600,
    };
    const price: SxProps<Theme> = {
      marginTop: 1,
      fontSize: { xs: 12, md: 13 },
      fontWeight: 500,
    };
    return { card, link, image, cardContent, category, title, price };
  };

  const style = getStyle();

 const priceParse =  parseInt(price);
const comparePriceParse = parseInt(comparePrice);

const discount = ((comparePriceParse - priceParse) / comparePriceParse * 100)

  return (
    <Card elevation={0} sx={style.card}>
      <Link component={RouterDom} sx={style.link} to={to}>
        <CardActionArea
          TouchRippleProps={{
            style: { color: theme.palette.primary[100] },
          }}
        >
          <Box position="relative" m={{ xs: 1, md: 2 }}>
            <CardMedia
              sx={style.image}
              alt={alt}
              component="img"
              loading="lazy"
              image={image}
            />
            {comparePriceParse && (
               <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              gap={1}
              width="autos"
              padding="0px 5px"
              height={25}
              bgcolor={theme.palette.primary[100]}
              position="absolute"
              top={4}
              right={4}
              zIndex={999}
              borderRadius={2}
            >
              <Percent
                htmlColor={theme.palette.warning.main}
                sx={{ width: 13, height: 13 }}
              />
              <Typography
                lineHeight={0}
                fontSize={12}
                fontWeight={700}
                sx={{ color: theme.palette.warning.main }}
              >
                {discount}%
              </Typography>
            </Box>
            )}
           
          </Box>
          <CardContent sx={style.cardContent}>
            <Typography sx={style.category}>{category}</Typography>
            <Typography sx={style.title}>{title}</Typography>
            <Box display="flex" justifyContent="space-between">
              {comparePrice && (
                <Typography
                  sx={[style.price, { textDecoration: "line-through" }]}
                  color="warning"
                >
                  ${comparePrice} {currency}
                </Typography>
              )}

              <Typography sx={style.price} color="secondary">
                ${price} {currency}
              </Typography>
            </Box>
          </CardContent>
        </CardActionArea>
      </Link>
    </Card>
  );
};
